import React, { useEffect, useState } from 'react'
import Longtitle from '../../../assets/images/logo-s.png'


import LongoS from '../../../assets/images/logo-s.png'




import { Link } from 'react-router-dom'
import './index.scss'
import AnimatedLetters from '../../AnimatedLetters'
import Logo from '../../Logo'
import Loader from 'react-loaders'
function Home() {
  const [letterClass, setLettersClass] = useState("text-animate")

  const [imageClass, setImageClass] = useState("");

  // .text-animate-hover
  useEffect(()=>{
    return()=> setTimeout(()=>{
      setLettersClass("text-animate-hover")


    },4000)
  },[])

  useEffect(() => {
    setTimeout(() => {
        setImageClass('translateYComes');
    }, 1000);
}, []);

  const nameArray = ['a', 'm', 'i'];
  const jobArray = ['F', 'r', 'o', 'n', 't', 'e', 'n', 'd', ' ', 'D', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r'];

  return (
    
<>
  <div className="container-short">

  
    <div className='container home-page '>
<div className="grid-templet">
        <div className="text-zone">
            <h1>
              <span className={`${letterClass} _11`}>H</span>
              <span className={`${letterClass} _12`}>i,</span>

               <br />
       
              <span className={`${letterClass} _13`}>I</span>
              <span className={`${letterClass} _14`}>'m</span>



            <img src={Longtitle} alt="" />
            <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={8}/>
            <br />
            <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={22}/>
            
            </h1>
            <h2>Frontend Developer</h2>
            <Link to='/contact'  className='flat-button'>CONTACT ME </Link>
        </div>

{/* <Logo/> */}
<div className={`image  ${imageClass}`}>

<img
  className="solid-logo-sam"
  alt="JavaScript,  Developer"
  src={LongoS}
/>

</div>

     
    </div>
</div>
</div>
    <Loader type="pacman" />
    
    </>

  )
}

export default Home
